"use client";

import { useGetAllUser, useGetUserTaxDetailData } from "@/hooks/useCommon";
import BookingTable from "./common/Table";
import React, { useEffect, useState } from "react";
import { useAuth } from "@/store/auth";
import { Pencil, Trash2 } from "lucide-react";

interface CancellationFees {
  sno: string;
  booking_module: string;
  booking_type: string;
  vehicle_type: string;
  cancellation: string;
  type: string;
  fees: string;
  created_by: string;
  action: string;
}

const userDetails = useAuth.getState().user;
export default function CancellationFeesTable() {
  const {
    data: userTaxDetails,
    isLoading,
    isError,
  } = useGetUserTaxDetailData();
  

  const CancellationFeesData: CancellationFees[] =
    userTaxDetails?.data?.map((item: any, index: number) => ({
      sno: (index + 1).toString(),
      booking_module: item.booking_module || "N/A",
      booking_type: item.booking_type || "N/A",
      vehicle_type: item.charge_type || "N/A",
      cancellation: item.charge_type || "N/A",
      type: item.type || "N/A",
      fees: item.charge_type || "N/A",
      //   created_by: (() => {
      //     const user = allUser?.data?.users.find((u: any) => u.id == item.id);
      //     return user ? `${user.first_name} ${user.last_name}` : "N/A";
      //   })(),
      action: "",
    })) || [];

  interface Column {
    key: string;
    header: string;
    sortable?: boolean;
    filterable?: boolean;
    filterType?: any;
    render?: (value: any, row?: any) => React.ReactNode;
    hidden?: boolean;
  }

  const CancellationFeesColumns: Column[] = [
    { key: "sno", header: "S.No", sortable: true, filterable: true },
    {
      key: "booking_module",
      header: "Booking Module",
      sortable: true,
      filterable: true,
    },
    {
      key: "booking_type",
      header: "Booking Type",
      sortable: true,
      filterable: true,
    },
    {
      key: "vehicle_type",
      header: "Vehicle Type",
      sortable: true,
      filterable: true,
    },
    {
      key: "cancellation",
      header: "Cancellation",
      sortable: true,
      filterable: true,
    },
    {
      key: "type",
      header: "Type",
      sortable: true,
      filterable: true,
    },
    {
      key: "fees",
      header: "Fees",
      sortable: true,
      filterable: true,
    },
    {
      key: "created_by",
      header: "Created By",
      sortable: true,
      filterable: true,
    },
    {
      key: "action",
      header: "Action",
      sortable: false,
      render: (_: string, row: any) => (
        <div className="flex items-center gap-1">
          <button
            onClick={(e) => {
              e.stopPropagation();
              alert(`Viewing User ${row.userId}`);
            }}
            className="text-xs hover:text-blue-600 font-medium cursor-pointer"
          >
            {/* View */}
            <Pencil className="w-4 h-4" />
          </button>

          <button className="text-xs hover:text-red-600 font-medium cursor-pointer">
            {/* Delete */}
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      ),
    },
  ];
  return (
    <div className="space-y-3 w-full pt-10 px-6">
      <BookingTable
        data={CancellationFeesData}
        columns={CancellationFeesColumns}
        sortable={false}
        filterable={false}
        searchable={false}
      />
    </div>
  );
}
